import dayjs from 'dayjs';

export class MockedVitoligno300CFeatures {
  mock(installationId: number, gatewaySerial: string) {
    return [
      {
        properties: {
          unit: {
            value: 'percent',
            type: 'string',
          },
          value: {
            type: 'number',
            value: 0,
            unit: 'percent',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.boiler.airflaps.0.position.current',
        gatewayId: gatewaySerial,
        feature: 'heating.boiler.airflaps.0.position.current',
        timestamp: '2022-08-11T11:44:09.186Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'string',
            value: 'bufferCharging',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.solar.status',
        gatewayId: gatewaySerial,
        feature: 'heating.solar.status',
        timestamp: '2022-08-12T07:23:51.838Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 65535,
            unit: 'kilogram',
          },
        },
        commands: {
          setMinimalFilling: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.device.fuel.minimal/commands/setMinimalFilling',
            name: 'setMinimalFilling',
            isExecutable: true,
            params: {
              minimalFilling: {
                required: true,
                constraints: {
                  min: 0,
                  max: 30000,
                  stepping: 1,
                },
                type: 'number',
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.device.fuel.minimal',
        gatewayId: gatewaySerial,
        feature: 'heating.device.fuel.minimal',
        timestamp: '2022-08-11T11:44:09.001Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          enabled: {
            type: 'array',
            value: ['0'],
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.burners',
        gatewayId: gatewaySerial,
        feature: 'heating.burners',
        timestamp: '2022-08-11T11:44:09.207Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          temperature: {
            value: 21,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.eco/commands/activate',
            name: 'activate',
            isExecutable: false,
            params: {},
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.eco/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.eco',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.eco',
        timestamp: '2022-08-11T04:30:26.815Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          profile: {
            value: 'none',
            type: 'string',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.2.operating.programs.screedDrying/commands/activate',
            name: 'activate',
            isExecutable: false,
            params: {
              profile: {
                type: 'string',
                required: true,
                constraints: {
                  enum: [
                    'profileOne',
                    'profileTwo',
                    'profileThree',
                    'profileFour',
                    'profileFive',
                    'profileSix',
                  ],
                },
              },
            },
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.2.operating.programs.screedDrying/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.operating.programs.screedDrying',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.operating.programs.screedDrying',
        timestamp: '2022-08-11T04:30:26.815Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.burners.0.manualActivation/commands/activate',
            name: 'activate',
            isExecutable: false,
            params: {},
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.burners.0.manualActivation/commands/deactivate',
            name: 'deactivate',
            isExecutable: true,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.burners.0.manualActivation',
        gatewayId: gatewaySerial,
        feature: 'heating.burners.0.manualActivation',
        timestamp: '2022-08-11T04:30:26.815Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 0,
            unit: 'percent',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.burners.0.current.power',
        gatewayId: gatewaySerial,
        feature: 'heating.burners.0.current.power',
        timestamp: '2022-08-11T11:44:09.240Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.operating.modes.heating',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.operating.modes.heating',
        timestamp: '2022-08-11T04:30:26.815Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          profile: {
            value: 'none',
            type: 'string',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.screedDrying/commands/activate',
            name: 'activate',
            isExecutable: false,
            params: {
              profile: {
                type: 'string',
                required: true,
                constraints: {
                  enum: [
                    'profileOne',
                    'profileTwo',
                    'profileThree',
                    'profileFour',
                    'profileFive',
                    'profileSix',
                  ],
                },
              },
            },
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.screedDrying/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.programs.screedDrying',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.programs.screedDrying',
        timestamp: '2022-08-11T04:30:26.815Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.modes.heating',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.modes.heating',
        timestamp: '2022-08-11T04:30:26.815Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          demand: {
            value: 'unknown',
            type: 'string',
          },
          temperature: {
            value: 21,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.normal/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 10,
                  max: 37,
                  stepping: 1,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.normal',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.normal',
        timestamp: '2022-08-11T11:44:28.982Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            value: 'heating',
            type: 'string',
          },
        },
        commands: {
          setMode: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.modes.active/commands/setMode',
            name: 'setMode',
            isExecutable: true,
            params: {
              mode: {
                type: 'string',
                required: true,
                constraints: {
                  enum: ['standby', 'heating'],
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.modes.active',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.modes.active',
        timestamp: '2022-08-11T11:44:17.010Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            value: 'heating',
            type: 'string',
          },
        },
        commands: {
          setMode: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.modes.active/commands/setMode',
            name: 'setMode',
            isExecutable: true,
            params: {
              mode: {
                type: 'string',
                required: true,
                constraints: {
                  enum: ['standby', 'heating'],
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.modes.active',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.modes.active',
        timestamp: '2022-08-11T11:44:16.839Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.operating.programs.heatDissipation',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.operating.programs.heatDissipation',
        timestamp: '2022-08-11T11:44:09.031Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.programs.heatDissipation',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.programs.heatDissipation',
        timestamp: '2022-08-11T11:44:09.025Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'off',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.circulation.pump',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.circulation.pump',
        timestamp: '2022-08-11T18:24:27.303Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          demand: {
            value: 'unknown',
            type: 'string',
          },
          temperature: {
            value: 21,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.reduced/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 3,
                  max: 37,
                  stepping: 1,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.programs.reduced',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.programs.reduced',
        timestamp: '2022-08-11T11:44:29.795Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          temperature: {
            value: 21,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.eco/commands/activate',
            name: 'activate',
            isExecutable: false,
            params: {},
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.eco/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.programs.eco',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.programs.eco',
        timestamp: '2022-08-11T04:30:26.815Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'off',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.frostprotection',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.frostprotection',
        timestamp: '2022-08-11T11:44:10.134Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            unit: 'minute',
            value: 96,
            type: 'number',
          },
          unit: {
            value: 'minute',
            type: 'string',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.device.time.offset',
        gatewayId: gatewaySerial,
        feature: 'heating.device.time.offset',
        timestamp: '2022-08-11T04:30:26.815Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'connected',
          },
          unit: {
            value: 'celsius',
            type: 'string',
          },
          value: {
            type: 'number',
            value: 19.9,
            unit: 'celsius',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.flue.sensors.temperature.main',
        gatewayId: gatewaySerial,
        feature: 'heating.flue.sensors.temperature.main',
        timestamp: '2022-08-11T11:44:18.323Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          unit: {
            value: 'celsius',
            type: 'string',
          },
          value: {
            type: 'number',
            value: 20.2,
            unit: 'celsius',
          },
          status: {
            type: 'string',
            value: 'connected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.sensors.temperature.return',
        gatewayId: gatewaySerial,
        feature: 'heating.sensors.temperature.return',
        timestamp: '2022-08-12T09:00:08.356Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          unit: {
            value: 'percent',
            type: 'string',
          },
          value: {
            type: 'number',
            value: 0,
            unit: 'percent',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.boiler.airflaps.1.position.current',
        gatewayId: gatewaySerial,
        feature: 'heating.boiler.airflaps.1.position.current',
        timestamp: '2022-08-11T11:44:09.189Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          unit: {
            value: 'celsius',
            type: 'string',
          },
          value: {
            type: 'number',
            value: 23.9,
            unit: 'celsius',
          },
          status: {
            type: 'string',
            value: 'connected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.sensors.temperature.supply',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.sensors.temperature.supply',
        timestamp: '2022-08-11T20:26:30.849Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          shift: {
            type: 'number',
            unit: '',
            value: -9,
          },
          slope: {
            type: 'number',
            unit: '',
            value: 0.3,
          },
        },
        commands: {
          setCurve: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.heating.curve/commands/setCurve',
            name: 'setCurve',
            isExecutable: true,
            params: {
              slope: {
                type: 'number',
                required: true,
                constraints: {
                  min: 0.2,
                  max: 3.5,
                  stepping: 0.1,
                },
              },
              shift: {
                type: 'number',
                required: true,
                constraints: {
                  min: -13,
                  max: 40,
                  stepping: 1,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.heating.curve',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.heating.curve',
        timestamp: '2022-08-11T04:30:26.815Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.operating.programs.dhwPrecedence',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.operating.programs.dhwPrecedence',
        timestamp: '2022-08-11T11:44:09.047Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          shift: {
            type: 'number',
            unit: '',
            value: -5,
          },
          slope: {
            type: 'number',
            unit: '',
            value: 0.4,
          },
        },
        commands: {
          setCurve: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.heating.curve/commands/setCurve',
            name: 'setCurve',
            isExecutable: true,
            params: {
              slope: {
                type: 'number',
                required: true,
                constraints: {
                  min: 0.2,
                  max: 3.5,
                  stepping: 0.1,
                },
              },
              shift: {
                type: 'number',
                required: true,
                constraints: {
                  min: -13,
                  max: 40,
                  stepping: 1,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.heating.curve',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.heating.curve',
        timestamp: '2022-08-11T04:30:26.815Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          demand: {
            value: 'unknown',
            type: 'string',
          },
          temperature: {
            value: 17,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.2.operating.programs.reduced/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 3,
                  max: 37,
                  stepping: 1,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.operating.programs.reduced',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.operating.programs.reduced',
        timestamp: '2022-08-11T11:44:29.835Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.modes.heating',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.modes.heating',
        timestamp: '2022-08-11T04:30:26.815Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.programs.dhwPrecedence',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.programs.dhwPrecedence',
        timestamp: '2022-08-11T11:44:09.043Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.modes.standby',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.modes.standby',
        timestamp: '2022-08-11T04:30:26.815Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          unit: {
            value: 'percent',
            type: 'string',
          },
          value: {
            type: 'number',
            value: 75.7,
            unit: 'percent',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.boiler.ash.level.current',
        gatewayId: gatewaySerial,
        feature: 'heating.boiler.ash.level.current',
        timestamp: '2022-08-11T11:44:09.192Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.programs.frostprotection',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.programs.frostprotection',
        timestamp: '2022-08-11T11:44:08.988Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          unit: {
            value: 'celsius',
            type: 'string',
          },
          value: {
            type: 'array',
            value: [196, 164, 109, 83],
            unit: 'celsius',
          },
          status: {
            type: 'array',
            value: ['connected', 'connected', 'connected', 'connected'],
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.buffer.sensors.temperature.stratification',
        gatewayId: gatewaySerial,
        feature: 'heating.buffer.sensors.temperature.stratification',
        timestamp: '2022-08-12T09:04:00.394Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.modes.standby',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.modes.standby',
        timestamp: '2022-08-11T04:30:26.815Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: true,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.solar',
        gatewayId: gatewaySerial,
        feature: 'heating.solar',
        timestamp: '2022-08-11T11:44:18.058Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'string',
            value: 'mixerSaving',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.active',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.active',
        timestamp: '2022-08-11T19:05:16.246Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          unit: {
            value: 'celsius',
            type: 'string',
          },
          value: {
            type: 'number',
            value: 24.5,
            unit: 'celsius',
          },
          status: {
            type: 'string',
            value: 'connected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.sensors.temperature.supply',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.sensors.temperature.supply',
        timestamp: '2022-08-11T23:43:49.847Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          demand: {
            value: 'unknown',
            type: 'string',
          },
          temperature: {
            value: 20,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.comfort/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 1,
                  max: 37,
                  stepping: 1,
                },
              },
            },
          },
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.comfort/commands/activate',
            name: 'activate',
            isExecutable: true,
            params: {
              temperature: {
                type: 'number',
                required: false,
                constraints: {
                  min: 1,
                  max: 37,
                  stepping: 1,
                },
              },
            },
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.comfort/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.comfort',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.comfort',
        timestamp: '2022-08-11T11:44:28.912Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          start: {
            value: '',
            type: 'string',
          },
          end: {
            value: '',
            type: 'string',
          },
        },
        commands: {
          changeEndDate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.operating.programs.holiday/commands/changeEndDate',
            name: 'changeEndDate',
            isExecutable: false,
            params: {
              end: {
                type: 'string',
                required: true,
                constraints: {
                  regEx: '^[\\d]{4}-[\\d]{2}-[\\d]{2}$',
                  sameDayAllowed: false,
                },
              },
            },
          },
          schedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.operating.programs.holiday/commands/schedule',
            name: 'schedule',
            isExecutable: true,
            params: {
              start: {
                type: 'string',
                required: true,
                constraints: {
                  regEx: '^[\\d]{4}-[\\d]{2}-[\\d]{2}$',
                },
              },
              end: {
                type: 'string',
                required: true,
                constraints: {
                  regEx: '^[\\d]{4}-[\\d]{2}-[\\d]{2}$',
                  sameDayAllowed: false,
                },
              },
            },
          },
          unschedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.operating.programs.holiday/commands/unschedule',
            name: 'unschedule',
            isExecutable: true,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.operating.programs.holiday',
        gatewayId: gatewaySerial,
        feature: 'heating.operating.programs.holiday',
        timestamp: '2022-08-11T04:30:26.815Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.configuration.multiFamilyHouse',
        gatewayId: gatewaySerial,
        feature: 'heating.configuration.multiFamilyHouse',
        timestamp: '2022-08-11T04:30:26.815Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.heatDissipation',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.heatDissipation',
        timestamp: '2022-08-11T11:44:09.022Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: true,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.programs.mixerSaving',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.programs.mixerSaving',
        timestamp: '2022-08-11T19:05:21.847Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'error',
          },
          unit: {
            value: 'percent',
            type: 'string',
          },
          value: {
            type: 'number',
            value: 21,
            unit: 'percent',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.flue.sensors.o2.lambda',
        gatewayId: gatewaySerial,
        feature: 'heating.flue.sensors.o2.lambda',
        timestamp: '2022-08-11T11:44:18.707Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'string',
            value: 'VL300C 24kW',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.variant',
        gatewayId: gatewaySerial,
        feature: 'device.variant',
        timestamp: '2022-08-11T11:44:18.161Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          hoursUnit: {
            value: 'hour',
            type: 'string',
          },
          hours: {
            type: 'number',
            value: 6579,
            unit: 'hour',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.solar.statistics',
        gatewayId: gatewaySerial,
        feature: 'heating.solar.statistics',
        timestamp: '2022-08-12T08:48:55.215Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          unit: {
            value: 'celsius',
            type: 'string',
          },
          value: {
            type: 'number',
            value: 20.2,
            unit: 'celsius',
          },
          status: {
            type: 'string',
            value: 'connected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.boiler.sensors.temperature.main',
        gatewayId: gatewaySerial,
        feature: 'heating.boiler.sensors.temperature.main',
        timestamp: '2022-08-11T11:44:08.981Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'off',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.frostprotection',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.frostprotection',
        timestamp: '2022-08-11T11:44:10.124Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          entries: {
            value: {
              mon: [
                {
                  start: '06:30',
                  end: '17:30',
                  mode: 'normal',
                  position: 0,
                },
              ],
              tue: [
                {
                  start: '06:30',
                  end: '17:30',
                  mode: 'normal',
                  position: 0,
                },
              ],
              wed: [
                {
                  start: '06:30',
                  end: '17:30',
                  mode: 'normal',
                  position: 0,
                },
              ],
              thu: [
                {
                  start: '06:30',
                  end: '17:30',
                  mode: 'normal',
                  position: 0,
                },
              ],
              fri: [
                {
                  start: '06:30',
                  end: '17:30',
                  mode: 'normal',
                  position: 0,
                },
              ],
              sat: [
                {
                  start: '06:30',
                  end: '17:30',
                  mode: 'normal',
                  position: 0,
                },
              ],
              sun: [
                {
                  start: '06:30',
                  end: '17:30',
                  mode: 'normal',
                  position: 0,
                },
              ],
            },
            type: 'Schedule',
          },
        },
        commands: {
          setSchedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.2.heating.schedule/commands/setSchedule',
            name: 'setSchedule',
            isExecutable: true,
            params: {
              newSchedule: {
                type: 'Schedule',
                required: true,
                constraints: {
                  modes: ['normal'],
                  maxEntries: 4,
                  resolution: 10,
                  defaultMode: 'reduced',
                  overlapAllowed: true,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.heating.schedule',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.heating.schedule',
        timestamp: '2022-08-11T04:30:26.815Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.summerSaving',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.summerSaving',
        timestamp: '2022-08-11T19:05:16.142Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          demand: {
            value: 'unknown',
            type: 'string',
          },
          temperature: {
            value: 21,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.normal/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 10,
                  max: 37,
                  stepping: 1,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.programs.normal',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.programs.normal',
        timestamp: '2022-08-11T11:44:28.984Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'off',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.circulation.pump',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.circulation.pump',
        timestamp: '2022-08-11T18:24:22.976Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          activeBurnerHoursSinceLastService: {
            type: 'number',
            value: -1,
            unit: '',
          },
          serviceIntervalBurnerHours: {
            type: 'number',
            value: -1,
            unit: '',
          },
          lastService: {
            type: 'string',
            value: '1970-01-01T00:00:00.000Z',
          },
          serviceDue: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {
          setHourInterval: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.service.burnerBased/commands/setHourInterval',
            name: 'setHourInterval',
            isExecutable: true,
            params: {
              hour: {
                required: true,
                constraints: {
                  min: 10,
                  max: 5000,
                  stepping: 1,
                },
                type: 'number',
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.service.burnerBased',
        gatewayId: gatewaySerial,
        feature: 'heating.service.burnerBased',
        timestamp: '2022-08-11T11:44:18.081Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'string',
            value: 'mixerSaving',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.programs.active',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.programs.active',
        timestamp: '2022-08-11T19:05:21.885Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            value: 65535,
            type: 'number',
            unit: 'kilogram',
          },
        },
        commands: {
          refillTank: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.device.fuel.current/commands/refillTank',
            name: 'refillTank',
            isExecutable: true,
            params: {
              refillWeight: {
                type: 'number',
                required: true,
                constraints: {
                  min: 1,
                  max: -35535,
                  stepping: 1,
                },
              },
            },
          },
          adjustTank: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.device.fuel.current/commands/adjustTank',
            name: 'adjustTank',
            isExecutable: true,
            params: {
              adjustWeight: {
                type: 'number',
                required: true,
                constraints: {
                  min: 1,
                  max: 30000,
                  stepping: 1,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.device.fuel.current',
        gatewayId: gatewaySerial,
        feature: 'heating.device.fuel.current',
        timestamp: '2022-08-11T04:30:26.815Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          hoursUnit: {
            value: 'hour',
            type: 'string',
          },
          hours: {
            type: 'number',
            value: 5604,
            unit: 'hour',
          },
          starts: {
            type: 'number',
            value: 3316,
            unit: '',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.burners.0.statistics',
        gatewayId: gatewaySerial,
        feature: 'heating.burners.0.statistics',
        timestamp: '2022-08-11T11:44:09.204Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          enabled: {
            value: ['0', '1', '2'],
            type: 'array',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits',
        timestamp: '2022-08-11T04:30:26.815Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'on',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.solar.pumps.circuit',
        gatewayId: gatewaySerial,
        feature: 'heating.solar.pumps.circuit',
        timestamp: '2022-08-12T07:23:51.823Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.operating.modes.standby',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.operating.modes.standby',
        timestamp: '2022-08-11T04:30:26.815Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          unit: {
            value: 'celsius',
            type: 'string',
          },
          status: {
            type: 'string',
            value: 'notConnected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.solar.sensors.temperature.dhw',
        gatewayId: gatewaySerial,
        feature: 'heating.solar.sensors.temperature.dhw',
        timestamp: '2022-08-11T11:44:18.046Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          unit: {
            value: 'celsius',
            type: 'string',
          },
          value: {
            type: 'number',
            value: 75,
            unit: 'celsius',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.boiler.temperature',
        gatewayId: gatewaySerial,
        feature: 'heating.boiler.temperature',
        timestamp: '2022-08-11T11:44:09.169Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.operating.programs.summerSaving',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.operating.programs.summerSaving',
        timestamp: '2022-08-11T11:44:09.016Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'string',
            value: 'buffer drawing',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.device.status',
        gatewayId: gatewaySerial,
        feature: 'heating.device.status',
        timestamp: '2022-08-11T15:54:28.859Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'string',
            value: 'off',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.boiler.operating.phase',
        gatewayId: gatewaySerial,
        feature: 'heating.boiler.operating.phase',
        timestamp: '2022-08-11T11:44:09.097Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 65535,
            unit: 'kilogram',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.configuration.fuel.capacity',
        gatewayId: gatewaySerial,
        feature: 'heating.configuration.fuel.capacity',
        timestamp: '2022-08-11T11:44:18.036Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 8,
            unit: '',
          },
        },
        commands: {
          setValue: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.3.heating.roomInfluenceFactor/commands/setValue',
            name: 'setValue',
            isExecutable: true,
            params: {
              value: {
                required: true,
                constraints: {
                  min: 0,
                  max: 64,
                  stepping: 1,
                },
                type: 'number',
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.3.heating.roomInfluenceFactor',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.3.heating.roomInfluenceFactor',
        timestamp: '2022-08-11T11:44:18.445Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          entries: {
            type: 'array',
            value: [],
            unit: '',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.messages.errors.raw',
        gatewayId: gatewaySerial,
        feature: 'device.messages.errors.raw',
        timestamp: '2022-08-11T11:44:18.787Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          demand: {
            value: 'unknown',
            type: 'string',
          },
          temperature: {
            value: 21,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.reduced/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 3,
                  max: 37,
                  stepping: 1,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.reduced',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.reduced',
        timestamp: '2022-08-11T11:44:29.751Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 8,
            unit: '',
          },
        },
        commands: {
          setValue: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.heating.roomInfluenceFactor/commands/setValue',
            name: 'setValue',
            isExecutable: true,
            params: {
              value: {
                required: true,
                constraints: {
                  min: 0,
                  max: 64,
                  stepping: 1,
                },
                type: 'number',
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.heating.roomInfluenceFactor',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.heating.roomInfluenceFactor',
        timestamp: '2022-08-11T11:44:18.352Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.operating.programs.frostprotection',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.operating.programs.frostprotection',
        timestamp: '2022-08-11T11:44:08.993Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          entries: {
            value: {
              mon: [
                {
                  start: '05:30',
                  end: '21:00',
                  mode: 'normal',
                  position: 0,
                },
              ],
              tue: [
                {
                  start: '05:30',
                  end: '21:00',
                  mode: 'normal',
                  position: 0,
                },
              ],
              wed: [
                {
                  start: '05:30',
                  end: '21:00',
                  mode: 'normal',
                  position: 0,
                },
              ],
              thu: [
                {
                  start: '05:30',
                  end: '21:00',
                  mode: 'normal',
                  position: 0,
                },
              ],
              fri: [
                {
                  start: '05:30',
                  end: '21:00',
                  mode: 'normal',
                  position: 0,
                },
              ],
              sat: [
                {
                  start: '05:30',
                  end: '21:00',
                  mode: 'normal',
                  position: 0,
                },
              ],
              sun: [
                {
                  start: '05:30',
                  end: '21:00',
                  mode: 'normal',
                  position: 0,
                },
              ],
            },
            type: 'Schedule',
          },
        },
        commands: {
          setSchedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.heating.schedule/commands/setSchedule',
            name: 'setSchedule',
            isExecutable: true,
            params: {
              newSchedule: {
                type: 'Schedule',
                required: true,
                constraints: {
                  modes: ['normal'],
                  maxEntries: 4,
                  resolution: 10,
                  defaultMode: 'reduced',
                  overlapAllowed: true,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.heating.schedule',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.heating.schedule',
        timestamp: '2022-08-11T04:30:26.815Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          name: {
            value: '',
            type: 'string',
          },
          type: {
            value: 'heatingCircuit',
            type: 'string',
          },
        },
        commands: {
          setName: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1/commands/setName',
            name: 'setName',
            isExecutable: false,
            params: {
              name: {
                type: 'string',
                required: true,
                constraints: {
                  minLength: 1,
                  maxLength: 20,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1',
        timestamp: '2022-08-11T04:30:26.815Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          unit: {
            value: 'kg',
            type: 'string',
          },
          value: {
            type: 'number',
            value: 18455,
            unit: 'kg',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.configuration.fuel.need',
        gatewayId: gatewaySerial,
        feature: 'heating.configuration.fuel.need',
        timestamp: '2022-08-11T11:44:18.023Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          name: {
            value: '',
            type: 'string',
          },
          type: {
            value: 'heatingCircuit',
            type: 'string',
          },
        },
        commands: {
          setName: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0/commands/setName',
            name: 'setName',
            isExecutable: false,
            params: {
              name: {
                type: 'string',
                required: true,
                constraints: {
                  minLength: 1,
                  maxLength: 20,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0',
        timestamp: '2022-08-11T04:30:26.815Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          unit: {
            value: 'celsius',
            type: 'string',
          },
          value: {
            type: 'number',
            value: 80.9,
            unit: 'celsius',
          },
          status: {
            type: 'string',
            value: 'connected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.solar.sensors.temperature.collector',
        gatewayId: gatewaySerial,
        feature: 'heating.solar.sensors.temperature.collector',
        timestamp: '2022-08-12T09:04:05.775Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            value: 'standby',
            type: 'string',
          },
        },
        commands: {
          setMode: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.2.operating.modes.active/commands/setMode',
            name: 'setMode',
            isExecutable: true,
            params: {
              mode: {
                type: 'string',
                required: true,
                constraints: {
                  enum: ['standby', 'heating'],
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.operating.modes.active',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.operating.modes.active',
        timestamp: '2022-08-11T11:44:17.051Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'off',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.boiler.pumps.circuit',
        gatewayId: gatewaySerial,
        feature: 'heating.boiler.pumps.circuit',
        timestamp: '2022-08-11T11:44:09.200Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          demand: {
            value: 'unknown',
            type: 'string',
          },
          temperature: {
            value: 20,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.comfort/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 1,
                  max: 37,
                  stepping: 1,
                },
              },
            },
          },
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.comfort/commands/activate',
            name: 'activate',
            isExecutable: true,
            params: {
              temperature: {
                type: 'number',
                required: false,
                constraints: {
                  min: 1,
                  max: 37,
                  stepping: 1,
                },
              },
            },
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.comfort/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.programs.comfort',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.programs.comfort',
        timestamp: '2022-08-11T11:44:28.917Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          profile: {
            value: 'none',
            type: 'string',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.screedDrying/commands/activate',
            name: 'activate',
            isExecutable: false,
            params: {
              profile: {
                type: 'string',
                required: true,
                constraints: {
                  enum: [
                    'profileOne',
                    'profileTwo',
                    'profileThree',
                    'profileFour',
                    'profileFive',
                    'profileSix',
                  ],
                },
              },
            },
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.screedDrying/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.screedDrying',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.screedDrying',
        timestamp: '2022-08-11T04:30:26.815Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.burners.0',
        gatewayId: gatewaySerial,
        feature: 'heating.burners.0',
        timestamp: '2022-08-11T11:44:09.210Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          unit: {
            value: 'celsius',
            type: 'string',
          },
          value: {
            type: 'number',
            value: 23.3,
            unit: 'celsius',
          },
          status: {
            type: 'string',
            value: 'connected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.sensors.temperature.supply',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.sensors.temperature.supply',
        timestamp: '2022-08-11T11:44:15.699Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          shift: {
            type: 'number',
            unit: '',
            value: -10,
          },
          slope: {
            type: 'number',
            unit: '',
            value: 0.4,
          },
        },
        commands: {
          setCurve: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.2.heating.curve/commands/setCurve',
            name: 'setCurve',
            isExecutable: true,
            params: {
              slope: {
                type: 'number',
                required: true,
                constraints: {
                  min: 0.2,
                  max: 3.5,
                  stepping: 0.1,
                },
              },
              shift: {
                type: 'number',
                required: true,
                constraints: {
                  min: -13,
                  max: 40,
                  stepping: 1,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.heating.curve',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.heating.curve',
        timestamp: '2022-08-11T04:30:26.815Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          shift: {
            type: 'number',
            unit: '',
            value: 0,
          },
          slope: {
            type: 'number',
            unit: '',
            value: 1.4,
          },
        },
        commands: {
          setCurve: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.3.heating.curve/commands/setCurve',
            name: 'setCurve',
            isExecutable: true,
            params: {
              slope: {
                type: 'number',
                required: true,
                constraints: {
                  min: 0.2,
                  max: 3.5,
                  stepping: 0.1,
                },
              },
              shift: {
                type: 'number',
                required: true,
                constraints: {
                  min: -13,
                  max: 40,
                  stepping: 1,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.3.heating.curve',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.3.heating.curve',
        timestamp: '2022-08-11T04:30:26.815Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.standby',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.standby',
        timestamp: '2022-08-11T04:30:26.815Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          demand: {
            value: 'unknown',
            type: 'string',
          },
          temperature: {
            value: 20,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.2.operating.programs.comfort/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 1,
                  max: 37,
                  stepping: 1,
                },
              },
            },
          },
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.2.operating.programs.comfort/commands/activate',
            name: 'activate',
            isExecutable: true,
            params: {
              temperature: {
                type: 'number',
                required: false,
                constraints: {
                  min: 1,
                  max: 37,
                  stepping: 1,
                },
              },
            },
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.2.operating.programs.comfort/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.operating.programs.comfort',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.operating.programs.comfort',
        timestamp: '2022-08-11T11:44:28.922Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.operating.programs.mixerSaving',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.operating.programs.mixerSaving',
        timestamp: '2022-08-11T11:44:09.090Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: true,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.mixerSaving',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.mixerSaving',
        timestamp: '2022-08-11T19:05:16.217Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 8,
            unit: '',
          },
        },
        commands: {
          setValue: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.heating.roomInfluenceFactor/commands/setValue',
            name: 'setValue',
            isExecutable: true,
            params: {
              value: {
                required: true,
                constraints: {
                  min: 0,
                  max: 64,
                  stepping: 1,
                },
                type: 'number',
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.heating.roomInfluenceFactor',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.heating.roomInfluenceFactor',
        timestamp: '2022-08-11T11:44:18.341Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.operating.programs.standby',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.operating.programs.standby',
        timestamp: '2022-08-11T04:30:26.815Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          temperature: {
            value: 17,
            unit: '',
            type: 'number',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.2.operating.programs.eco/commands/activate',
            name: 'activate',
            isExecutable: false,
            params: {},
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.2.operating.programs.eco/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.operating.programs.eco',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.operating.programs.eco',
        timestamp: '2022-08-11T04:30:26.815Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          name: {
            value: '',
            type: 'string',
          },
          type: {
            value: 'heatingCircuit',
            type: 'string',
          },
        },
        commands: {
          setName: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.2/commands/setName',
            name: 'setName',
            isExecutable: false,
            params: {
              name: {
                type: 'string',
                required: true,
                constraints: {
                  minLength: 1,
                  maxLength: 20,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2',
        timestamp: '2022-08-11T04:30:26.815Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          entries: {
            type: 'ErrorListChanges',
            constraints: {},
            value: {
              new: [],
              current: [],
              gone: [],
            },
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.errors.active',
        gatewayId: gatewaySerial,
        feature: 'heating.errors.active',
        timestamp: '2022-08-10T17:20:50.654Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.programs.standby',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.programs.standby',
        timestamp: '2022-08-11T04:30:26.815Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          entries: {
            value: {
              mon: [
                {
                  start: '05:00',
                  end: '21:00',
                  mode: 'normal',
                  position: 0,
                },
              ],
              tue: [
                {
                  start: '05:00',
                  end: '21:00',
                  mode: 'normal',
                  position: 0,
                },
              ],
              wed: [
                {
                  start: '05:00',
                  end: '21:00',
                  mode: 'normal',
                  position: 0,
                },
              ],
              thu: [
                {
                  start: '05:00',
                  end: '21:00',
                  mode: 'normal',
                  position: 0,
                },
              ],
              fri: [
                {
                  start: '05:00',
                  end: '21:00',
                  mode: 'normal',
                  position: 0,
                },
              ],
              sat: [
                {
                  start: '05:00',
                  end: '21:00',
                  mode: 'normal',
                  position: 0,
                },
              ],
              sun: [
                {
                  start: '05:00',
                  end: '21:00',
                  mode: 'normal',
                  position: 0,
                },
              ],
            },
            type: 'Schedule',
          },
        },
        commands: {
          setSchedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.heating.schedule/commands/setSchedule',
            name: 'setSchedule',
            isExecutable: true,
            params: {
              newSchedule: {
                type: 'Schedule',
                required: true,
                constraints: {
                  modes: ['normal'],
                  maxEntries: 4,
                  resolution: 10,
                  defaultMode: 'reduced',
                  overlapAllowed: true,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.heating.schedule',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.heating.schedule',
        timestamp: '2022-08-11T04:30:26.815Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          entries: {
            type: 'ErrorListChanges',
            constraints: {},
            value: {
              new: [],
              current: [],
              gone: [],
            },
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.messages.warnings.active',
        gatewayId: gatewaySerial,
        feature: 'device.messages.warnings.active',
        timestamp: '2022-08-10T17:20:50.345Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'off',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.circulation.pump',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.circulation.pump',
        timestamp: '2022-08-11T18:24:22.940Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.dhwPrecedence',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.dhwPrecedence',
        timestamp: '2022-08-11T11:44:09.038Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 8,
            unit: '',
          },
        },
        commands: {
          setValue: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.2.heating.roomInfluenceFactor/commands/setValue',
            name: 'setValue',
            isExecutable: true,
            params: {
              value: {
                required: true,
                constraints: {
                  min: 0,
                  max: 64,
                  stepping: 1,
                },
                type: 'number',
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.heating.roomInfluenceFactor',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.heating.roomInfluenceFactor',
        timestamp: '2022-08-11T11:44:18.399Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'on',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.solar.rechargeSuppression',
        gatewayId: gatewaySerial,
        feature: 'heating.solar.rechargeSuppression',
        timestamp: '2022-08-12T07:23:59.167Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          demand: {
            value: 'unknown',
            type: 'string',
          },
          temperature: {
            value: 17,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.2.operating.programs.normal/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 10,
                  max: 37,
                  stepping: 1,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.operating.programs.normal',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.operating.programs.normal',
        timestamp: '2022-08-11T11:44:28.987Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'off',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.frostprotection',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.frostprotection',
        timestamp: '2022-08-11T11:44:10.102Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          unit: {
            value: 'kilowattHour',
            type: 'string',
          },
          day: {
            type: 'array',
            value: [26, 203, 199, 174, 202, 201, 141, 58],
            unit: 'kilowattHour',
          },
          week: {
            type: 'array',
            value: [],
            unit: 'kilowattHour',
          },
          month: {
            type: 'array',
            value: [],
            unit: 'kilowattHour',
          },
          year: {
            type: 'array',
            value: [],
            unit: 'kilowattHour',
          },
          dayValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          weekValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          monthValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          yearValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.solar.power.production',
        gatewayId: gatewaySerial,
        feature: 'heating.solar.power.production',
        timestamp: '2022-08-12T09:02:40.760Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.programs.summerSaving',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.programs.summerSaving',
        timestamp: '2022-08-11T19:05:21.806Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          serviceIntervalMonths: {
            value: -1,
            unit: '',
            type: 'number',
          },
          serviceDue: {
            value: false,
            type: 'boolean',
          },
          nextService: {
            value: '1970-01-01',
            type: 'string',
          },
          lastService: {
            value: '1970-01-01T00:00:00.000Z',
            type: 'string',
          },
          activeMonthSinceLastService: {
            value: -1,
            unit: '',
            type: 'number',
          },
        },
        commands: {
          confirmService: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.service.timeBased/commands/confirmService',
            name: 'confirmService',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.service.timeBased',
        gatewayId: gatewaySerial,
        feature: 'heating.service.timeBased',
        timestamp: '2022-08-11T04:30:26.815Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.frostprotection',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.frostprotection',
        timestamp: '2022-08-11T11:44:08.984Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          entries: {
            type: 'array',
            value: [],
            unit: '',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.messages.warnings.raw',
        gatewayId: gatewaySerial,
        feature: 'device.messages.warnings.raw',
        timestamp: '2022-08-11T11:44:09.172Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'string',
            value: 'standby',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.operating.programs.active',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.operating.programs.active',
        timestamp: '2022-08-11T11:44:15.935Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          unit: {
            value: 'percent',
            type: 'string',
          },
          value: {
            type: 'number',
            value: 0,
            unit: 'percent',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.boiler.pumps.circuit.power.current',
        gatewayId: gatewaySerial,
        feature: 'heating.boiler.pumps.circuit.power.current',
        timestamp: '2022-08-11T11:44:09.197Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          unit: {
            value: 'celsius',
            type: 'string',
          },
          value: {
            type: 'number',
            value: 21.7,
            unit: 'celsius',
          },
          status: {
            type: 'string',
            value: 'connected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.sensors.temperature.outside',
        gatewayId: gatewaySerial,
        feature: 'heating.sensors.temperature.outside',
        timestamp: '2022-08-12T08:45:56.387Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        apiVersion: 1,
        isEnabled: true,
        isReady: true,
        timestamp: '2022-08-11T04:30:26.815Z',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.name',
        feature: 'heating.circuits.0.name',
        deviceId: '0',
        gatewayId: gatewaySerial,
        commands: {
          setName: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.name/commands/setName',
            name: 'setName',
            isExecutable: true,
            params: {
              name: {
                type: 'string',
                required: true,
                constraints: {
                  minLength: 1,
                  maxLength: 20,
                },
              },
            },
          },
        },
        properties: {
          name: {
            type: 'string',
            value: '',
          },
        },
      },
      {
        apiVersion: 1,
        isEnabled: true,
        isReady: true,
        timestamp: '2022-08-11T04:30:26.815Z',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.name',
        feature: 'heating.circuits.1.name',
        deviceId: '0',
        gatewayId: gatewaySerial,
        commands: {
          setName: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.name/commands/setName',
            name: 'setName',
            isExecutable: true,
            params: {
              name: {
                type: 'string',
                required: true,
                constraints: {
                  minLength: 1,
                  maxLength: 20,
                },
              },
            },
          },
        },
        properties: {
          name: {
            type: 'string',
            value: '',
          },
        },
      },
      {
        apiVersion: 1,
        isEnabled: true,
        isReady: true,
        timestamp: '2022-08-11T04:30:26.815Z',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.name',
        feature: 'heating.circuits.2.name',
        deviceId: '0',
        gatewayId: gatewaySerial,
        commands: {
          setName: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.2.name/commands/setName',
            name: 'setName',
            isExecutable: true,
            params: {
              name: {
                type: 'string',
                required: true,
                constraints: {
                  minLength: 1,
                  maxLength: 20,
                },
              },
            },
          },
        },
        properties: {
          name: {
            type: 'string',
            value: '',
          },
        },
      },
    ];
  }
}
